var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 37 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M35.68 5.909H.852a.391.391 0 0 1-.391-.392V.822C.462.606.637.43.853.43H35.68c.216 0 .391.175.391.39v4.696a.391.391 0 0 1-.39.392zM1.243 5.126h34.02V1.213H1.244v3.913zM35.68 30.24H.852a.391.391 0 0 1-.391-.391v-4.696c0-.216.175-.391.391-.391H35.68c.216 0 .391.175.391.391v4.696a.391.391 0 0 1-.39.391zm-34.436-.783h34.02v-3.913H1.244v3.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.602 25.529h-.125L3.592 16.083a.383.383 0 0 1-.266-.368.383.383 0 0 1 .266-.376L31.484 5.165a.391.391 0 0 1 .501.235.383.383 0 0 1-.219.509L4.891 15.69l26.875 9.079a.383.383 0 0 1 .25.493.391.391 0 0 1-.414.266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.586 25.529a.395.395 0 0 1-.11-.783l27.9-8.319L4.845 5.91a.391.391 0 0 1-.227-.501.391.391 0 0 1 .54-.235l28.573 10.91c.158.06.259.215.25.383a.4.4 0 0 1-.273.36L4.704 25.513l-.118.016z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLoading);
export default __webpack_public_path__ + "static/media/vertical-loading.0ca2c8c960c2303e2ca80bd0c98d0063.svg";
export { ForwardRef as ReactComponent };